import { render } from "./strategyItem.vue?vue&type=template&id=67ce3e02&scoped=true"
import script from "./strategyItem.vue?vue&type=script&lang=js"
export * from "./strategyItem.vue?vue&type=script&lang=js"

import "./strategyItem.vue?vue&type=style&index=0&id=67ce3e02&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ce3e02"]])

export default __exports__